import {BaseModel} from "../../base/models/base-model.model";
import {ExternalErrorModel} from "./external-error.model";

export class EobiErrorModel extends BaseModel {
  /**
   * The error code
   */
  private _code: string;
  /**
   * The error description
   */
  private _message: string;
  private _extraCode: string;
  private _extraField: Array<string>;
  private _externalErrors: Array<ExternalErrorModel>;
  private _extraMessage: string;

  constructor(code?: string, message?: string, extraCode?: string, extraField?: Array<string>, externalErrors?: Array<ExternalErrorModel>, extraMessage?: string) {
    super();
    this._code = code;
    this._message = message;
    this._extraCode = extraCode;
    this._extraField = extraField;
    this._externalErrors = externalErrors;
    this._extraMessage = extraMessage;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get message(): string {
    return this._message;
  }

  set message(value: string) {
    this._message = value;
  }

  get extraCode(): string {
    return this._extraCode;
  }

  set extraCode(value: string) {
    this._extraCode = value;
  }

  get extraField(): Array<string> {
    return this._extraField;
  }

  set extraField(value: Array<string>) {
    this._extraField = value;
  }

  get externalErrors(): Array<ExternalErrorModel> {
    return this._externalErrors;
  }

  set externalErrors(value: Array<ExternalErrorModel>) {
    this._externalErrors = value;
  }

  get extraMessage(): string {
    return this._extraMessage;
  }

  set extraMessage(value: string) {
    this._extraMessage = value;
  }
}
